<div class="form-group">
    <label [for]="id" [ngClass]="{ 'text-danger': !valid}">{{label | translate}}</label>
    <quill-editor #editor [(ngModel)]="value" [id]="id" [disabled]="disabled" [ngClass]="{ 'is-invalid': !valid}"
        placeholder="{{correctPlaceHolder | translate}}"
		[maxlength]="maxLength"
		>
    </quill-editor>
    <small *ngIf="!valid" class="form-text text-muted danger"><em>{{errorMessage}}</em></small>
</div>